const FUTURE_YEAR_LIMIT = 2;

// Duplicated from monthly-exam-event-list lib
export function getExamEventYearsSelectionOptions(years: number[], currentYear: number) {
  const defaultYearOptions = [...new Array(FUTURE_YEAR_LIMIT + 1)].map(
    (_, index) => currentYear + index,
  );
  const mergedYears = [...new Set([...years, ...defaultYearOptions])].sort((a, b) => b - a);

  return mergedYears.map((year) => ({ value: year, label: year.toString() }));
}
